<template>
<div class="chapter">
<div class="inner_page">
<p class="cn" id="ch5">SPRAWL</p>
<p class="v">Melons sprawl from root.</p>
<p class="v">In Pin riverlands, earth</p>
<p class="v">gave birth to our people.</p>
<p class="v">Our true old father T’ai</p>
<p class="v">made us shelters, kiln-huts,</p>
<p class="vsb">for houses were unknown.</p>
<p class="v">Then T’ai our true father</p>
<p class="v">went early on his horse,</p>
<p class="v">following the Wei River</p>
<p class="v">west to Bowhand Mountain,</p>
<p class="v">found Lady Shepherdess</p>
<p class="vsb">and with her shared roof.</p>
<p class="v">Chou plains rich and full,</p>
<p class="v">thistle-weed and bitterroot</p>
<p class="v">like honey-cake, he began</p>
<p class="v">planning. Tortoise shells</p>
<p class="v">said: <span class="epub-i">This place. This time.</span></p>
<p class="vsb">And soon houses were built.</p>
<p class="v">He comforted and he settled</p>
<p class="v">his people on every side,</p>
<p class="v">laid out bounds and borders,</p>
<p class="v">shaped fields, sent farmers</p>
<p class="v">east and west, everywhere</p>
<p class="vsb">fashioning his project well.</p>
<p class="v">He called master builders,</p>
<p class="v">master teachers, bade them</p>
<p class="v">build houses, plumb-lines</p>
<p class="v">taut and true, bade them</p>
<p class="v">lash timbers into that regal</p>
<p class="vsb">temple ancestors would love.</p>
<p class="v">We hauled earth in baskets,</p>
<p class="v">crowds swarming, measuring,</p>
<p class="v">packing it hard <span class="epub-i">hunk, hunk,</span></p>
<p class="v">scraping it clean <span class="epub-i">ping, ping:</span></p>
<p class="v">a hundred walls built so fast</p>
<p class="vsb">no work-drum could keep up.</p>
<p class="v">Soon outer gates stood firm,</p>
<p class="v">outer gates looming up, lofty,</p>
<p class="v">then inner gates stood firm,</p>
<p class="v">inner gates regal and strong.</p>
<p class="v">And soon the Earth Altar too,</p>
<p class="vsb">where all our endeavors begin.</p>
<p class="v">True T’ai—his righteous anger never faded,</p>
<p class="v">and he never let his great renown falter.</p>
<p class="v">He cleared oak and thorn-oak</p>
<p class="v">and opened roads far and wide.</p>
<p class="v">And the mud-faced tribes, they</p>
<p class="vsb">fled in broken-winded panic.</p>
<p class="v">Our neighbors in Yü and Jui pledged peace:</p>
<p class="v">Emperor Wen always kindled native nobility.</p>
<p class="v">And so we call him sovereign near and far,</p>
<p class="v">sovereign we call him over before and after,</p>
<p class="v">sovereign too over those who flee or return</p>
<p class="v">and even over those who ridicule and resist.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter5.vue?f633b986